export enum TicketTabs {
  Actual = 'actual',
  Archived = 'archived',
}
